/* @flow */
import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { createTransform, persistStore } from 'redux-persist-immutable';

/* Create Redux Store & local persistance layer */
import createStore from './createStore.js';

import { rootSerializer } from './modules';

import Root from './Root.js';

// NOTE: We don't seem to need to deserialize since we're using persist-immutable
const rehydrationTransform = createTransform(
  rootSerializer, // transform state coming from redux on its way to being serialized and stored
  (outgoing, key) => outgoing // transform state coming from storage, on its way to be rehydrated into redux
);

// Pass in browserHistory for routerMiddleware
const store = createStore(browserHistory);

persistStore(store, {
  whitelist: rootSerializer.keys,
  transforms: [rehydrationTransform],
});

const history = syncHistoryWithStore(browserHistory, store, {
  selectLocationState: state => state.get('router'),
});

/* Exposes globals. Debug module is exposed everywhere */
window.__$debug = require('debug');

window.addEventListener('unhandledrejection', function(event) {
  console.warn(`UNHANDLED PROMISE REJECTION: ${event.reason}`);
  if (event.reason.toString().match('Error: Loading chunk .* failed.')) {
    window.location.reload();
    event.preventDefault();
  }
});

if (process.env.NODE_ENV === 'development' || window.Cypress) {
  require('./expose-globals.js')(window, {
    store,
    _history: history,
    s: () => store.getState().toJS(),
    state: (kp) => kp ? store.getState().getIn(kp) : store.getState(),
  });
}

const renderDOM = Component => {
  if (process.env.NODE_ENV === 'development') {
    render(
      <AppContainer warnings={false}>
        <Component
          store={store}
          history={history}
        />
      </AppContainer>,
      document.getElementById('root')
    );
  } else {
    render(
      <Component
        store={store}
        history={history}
      />,
      document.getElementById('root')
    );
  }
};

// Render the App! NOTE: This will only be called this once in prod. In dev we
// hot reload (see below)
renderDOM(Root);

// Enable hot reloading (only in dev)
if (module.hot) {
  // $FlowIgnore
  module.hot.accept('./Root.js', () => {
    renderDOM(Root);
  });
}



// WEBPACK FOOTER //
// ./src/app/index.js